import React, { useRef } from "react";

import useDoughnutTotal from "./hooks/useDoughnutTotal";
import ChartColors from "../../../../config/ChartColors";

import Card from "../../../common/Card/Card";
import Typography from "../../../common/Typography/Typography";

import styles from "./DoughnutTotal.module.css";

interface Props {
    showAmountOrTotal?: "amount" | "total";
    title?: string;
    amount: number;
    total: number;
    label: string;
    color?: ChartColors;
    columnSpan?: "" | `col-span-${number}`;
    children?: React.ReactNode;
}

const DoughnutTotal = (props: Props) => {
    const { showAmountOrTotal = "total", title, amount, total, label, color, columnSpan, children } = props;
    const ref = useRef(null);

    useDoughnutTotal(ref, label, amount, total, color!);

    let percentage = Math.floor((amount / total) * 100);

    if (Number.isNaN(percentage)) {
        percentage = 0;
    }

    return (
        <Card padding="large" className={`${styles.card} ${columnSpan} max-w-full`}>
            {title ? (
                <Typography as="h3" variant="smallCaps">
                    {title}
                </Typography>
            ) : null}
            <div className={styles.mainContent}>
                <dl className={styles.dataset}>
                    <Typography as="dt" variant="smallCaps" color="pine">
                        {label}
                    </Typography>
                    <Typography as="dd" variant="figure" fontSize="800">
                        <span className="flex items-center gap-0.5">{showAmountOrTotal === "total" ? total : amount}</span>
                    </Typography>
                </dl>
                <div className={styles.doughnut}>
                    <Typography as="div" variant="figure" fontSize="800">
                        {percentage}%
                    </Typography>
                    <canvas className="w-[105px]" ref={ref} />
                </div>
            </div>
            {children || null}
        </Card>
    );
};

export default DoughnutTotal;
